import { GetTrainingFilesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

interface TrainingFilesProps {
  trainingId: number
  visibility?: boolean
  ids?: number[]
}

export const useTrainingFiles = ({ trainingId, visibility, ids }: TrainingFilesProps) => {
  const { loading, data } = useQuery(GetTrainingFilesDocument, {
    variables: { trainingId, visibility, ids },
  })

  return {
    loading,
    trainingFiles: data ? data.trainings.trainingFilesConnection.nodes : [], // Provide a default value
  }
}
